module.exports = __webpack_public_path__ + "img/Project-no-data.9b9c24e3.png";